import React from 'react';

import ModalContainer from 'src/views/components/ModalContainer';

import ConfirmationView from './components/ConfirmationView';

const ModalUnlinkIncident = () => (
  <ModalContainer title="Unlink PagerDuty Incident from Issue">
    <ConfirmationView/>
  </ModalContainer>
);

export default ModalUnlinkIncident;
